import { Box, styled, experimental_sx as sx, BoxProps } from '@mui/material';
import React, { FC } from 'react';

import { Icon } from '../Icon';

type CheckboxProps = BoxProps & {
  checked: boolean;
};

const CheckboxBox = styled(Box, {
  name: 'Checkbox',
  slot: 'Box',
  shouldForwardProp: (prop) => prop !== 'checked' && prop !== 'sx',
  overridesResolver: (props, styles) => {
    return [styles.root, props.checked && styles.checked];
  }
})<CheckboxProps>(({ checked }) =>
  sx({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 16,
    height: 16,
    color: 'common.white',
    bgcolor: 'common.white',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'dark.200',
    'input:hover ~ &': {
      borderColor: 'dark.400'
    },
    'input:disabled ~ &': {
      color: 'dark.200',
      backgroundColor: 'dark.100',
      borderColor: 'dark.100'
    },
    ...(checked && {
      bgcolor: 'primary.main',
      borderColor: 'primary.main',
      'input:hover ~ &': {
        backgroundColor: 'primary.dark',
        borderColor: 'transparent'
      },
      'input:disabled ~ &': {
        color: 'dark.200',
        backgroundColor: 'dark.100',
        borderColor: 'transparent'
      }
    })
  })
);

export const CheckedIcon: FC = () => {
  return (
    <CheckboxBox checked>
      <Icon
        name="CheckXS"
        sx={{ fontSize: 10, path: { fill: 'currentColor' } }}
        viewBox="0 0 8 8"
      />
    </CheckboxBox>
  );
};

export const NonCheckedIcon: FC = () => {
  return <CheckboxBox checked={false} />;
};

export const IndeterminateIcon: FC = () => {
  return (
    <CheckboxBox checked>
      <Icon
        name="MinusXS"
        sx={{ fontSize: 10, path: { fill: 'currentColor' } }}
        viewBox="0 0 8 8"
      />
    </CheckboxBox>
  );
};
